module.exports = __webpack_public_path__ + "img/logo-azul-sin-fondo.3ac37180.png";